module.exports = require("./sr-Cyrl-XK");